/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import { useNavigate } from "react-router";
import { useQuery } from "react-query";
import VendorManagerServices from "../../../services/API/VendorManager";
import AllianceManagerServices from "../../../services/API/AllianceManager";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Loader from "../../../components/Loader";
import { addDays, format } from "date-fns";
import Pagination from "react-js-pagination";
import UserFilter from "../../../components/UserFilter";
import { Link } from "react-router-dom";
import moment from "moment";
import useAuth from "../../../hooks/useAuth";
import { ROLES } from "../../../constant/roles";

const initial = {
  name: "",
  email: "",
  mobile_no: "",
  dueDateRange: [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ],
  dateSubmit: false,
};

const UserLists = () => {
  const vendor = {
    type: "active",
  };
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [adItem, setADItem] = useState("");
  const [enduserId, setEnduserId] = useState("");
  const [loader, setLoader] = useState("");
  const [showFilter, setShowFilter] = useState("");
  const [filters, setFilters] = useState(initial);
  const [displaySearchField, setDisplaySearchField] = useState(false);
  const [clearFilters, setCleafilters] = useState(false);
  const [showDuedateRange, setShowDuedateRange] = useState(false);
  const [showReqDateRange, setShowReqDateRange] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');
  const [q, setq] = useState("");
  const [limit, setLimit] = useState(20);
  const [userStatus, setUserStatus] = useState(false);
  const [enduserDeleteId, setEnduserDeleteId] = useState("");
  const auth = useAuth();

  // Calculate the start index and end index for current page
  const startIndex = +(page - 1) * limit;
  const endIndex = parseInt(startIndex + limit);

  const queryKey = `/api/vendor`;
  const {
    data: userLists,
    isFetching,
    isLoading: listLoading,
    isSuccess: success,
    isRefetching,
    refetch,
  } = useQuery(
    // [queryKey, { sortColumn: sortColumn, sortOrder: sortOrder }],
    [
      queryKey,
      {
        ...filters,
        q,
        limit: limit,
        page: page,
        start: startIndex,
        end: endIndex,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        status: "inactive",
      },
    ],
    AllianceManagerServices.getUsersLists,
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [userLists, page, sortColumn, sortOrder, startIndex, endIndex]);

  const updateVendorStatus = async () => {
    let statusToset = true;
    if (adItem?.is_enabled == 1) {
      statusToset = false;
    }
    setLoader("update");
    const resp = await VendorManagerServices.updateVendorStatus(
      adItem?.id,
      statusToset
    );
    setLoader("");
    setADItem(null);
    if (resp.data.is_enabled == 0) {
      toast.success("Vendor Deactivated Successfully");
      refetch();
    } else {
      toast.success("Vendor Activated Successfully");
      refetch();
    }
  };

  const handlePermission = async () => {
    setLoader("update");

    const res = await AllianceManagerServices.grantPermission(enduserId);
    if (res?.status == "success") {
      toast.success("Permission Granted Successfully");
      refetch();
    }
    setLoader("");
    setEnduserId(null);
  };
  const handleDelete = async () => {
    setLoader("update");

    const res = await AllianceManagerServices.handleDelete(enduserDeleteId);
    if (res?.status == "success") {
      toast.success("deleted Successfully");
      refetch();
    }
    setLoader("");
    setEnduserDeleteId(null);
  };
  const cellClasses = "d-flex align-items-center h-full  ";
  // const cellClasses = ""

  const handleSort = (column) => {
    if (sortColumn === column) {
      // Toggle sort order
      setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      // Set new sort column and default to ascending
      setSortColumn(column);
      setSortOrder('asc');
    }

  };

  const downloadReport = async () => {
    setLoader("download");
    const resp = await AllianceManagerServices.downloadUserReport("inactive");
    setLoader("");
    if (resp) {
      const url = window.URL.createObjectURL(new Blob([resp]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Users-Lists.csv");
      toast.success("Inactive End user list downloaded successfully.");
      link.click();
    }
  };

  return (
    <AliianceManagerLayout vendor="active">
      <AdminPageContainer>
        <Modal
          show={!!enduserId}
          onHide={() => setEnduserId(null)}
          animation={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Are you Sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you want to grant permission to this user?</p>
            <div className="d-flex gap-3 justify-content-end">
              <Button
                variant="danger"
                className="px-3 py-2"
                onClick={() => setEnduserId(null)}
                disabled={loader === "update"}
              >
                No
              </Button>
              <Button
                variant="success"
                className="px-3 py-2"
                onClick={() => handlePermission()}
                disabled={loader === "update"}
              >
                {loader === "update" ? (
                  <div className="d-flex align-items-center gap-2">
                    <Loader /> loading...
                  </div>
                ) : (
                  "Yes"
                )}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={!!enduserDeleteId}
          onHide={() => setEnduserDeleteId(null)}
          animation={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Are you Sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you want to delete this user?</p>
            <div className="d-flex gap-3 justify-content-end">
              <Button
                variant="danger"
                className="px-3 py-2"
                onClick={() => setEnduserDeleteId(null)}
                disabled={loader === "update"}
              >
                No
              </Button>
              <Button
                variant="success"
                className="px-3 py-2"
                onClick={() => handleDelete()}
                disabled={loader === "update"}
              >
                {loader === "update" ? (
                  <div className="d-flex align-items-center gap-2">
                    <Loader /> loading...
                  </div>
                ) : (
                  "Yes"
                )}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {showFilter && (
          <UserFilter
            show={showFilter}
            onHide={() => setShowFilter(false)}
            setFilters={setFilters}
            filters={filters}
            setPage={setPage}
            showDuedateRange={showDuedateRange}
            setShowDuedateRange={setShowDuedateRange}
          />
        )}
        <div id="main" role="main">
          <div id="content">
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/alliance-manager/dashboard"}>Home</Link>
                </li>
                <li className="breadcrumb-item active">User Lists</li>
              </ol>
            </div>
            <div className="card card-sm card-shadow mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  
                    <div>
                      <Link
                          className="button_new mt-1 px-3 mr-5 me-2 btn"
                          to={
                            auth?.roleId == ROLES.allianceManager
                              ? `/alliance-manager/user-lists`
                              : `/customer-support/user-lists`
                          }
                      >
                          Active User Lists
                      </Link>
                      <Link
                          className="button_new mt-1 px-3 mr-5 me-2 btn text-primary"
                          to={
                            auth?.roleId == ROLES.allianceManager
                              ? `/alliance-manager/inactive-user-lists`
                              : `/customer-support/inactive-user-lists`
                          }
                      >
                          Inactive User Lists
                      </Link>
                    </div>
                  <div className="d-flex justify-content-end align-items-center gap-2 pb-3">
                  <div>
                    <select
                      onChange={(e) => setLimit(e.target.value)}
                      value={limit}
                      className="button_new pull-right mt-1 px-3"
                      name="limit"
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                    </select>
                  </div>
                    {(!!filters?.name ||
                      !!filters?.email ||
                      !!filters?.mobile_no ||
                      filters.dateSubmit ||
                      !!q) && (
                      <button
                        type="button"
                        className="button_new pull-right mt-1 px-3"
                        onClick={() => {
                          setq("");
                          setDisplaySearchField(false);
                          setFilters(initial);
                          setShowDuedateRange(false);
                          setShowReqDateRange(false);
                        }}
                      >
                        Clear Filters
                      </button>
                    )}
                    {displaySearchField ? (
                      <label className="input m-0 mt-1">
                        <input
                          type="text"
                          className="button_new "
                          value={q}
                          onChange={(e) => {
                            setPage(1);
                            setq(e.target.value);
                          }}
                          placeholder="Search"
                        />
                      </label>
                    ) : (
                      <div>
                        <a
                          className=" button_new "
                          onClick={() => {
                            setDisplaySearchField(true);
                          }}
                          onKeyDown={() => {
                            setDisplaySearchField(true);
                          }}
                        >
                          <i
                            class="fa fa-fa fa-search requests-icons"
                            title="Search"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    )}
                    <div>
                      <a
                        // href=""
                        onClick={() => setShowFilter(true)}
                        onKeyDown={() => setShowFilter(true)}
                        target="_blank"
                        className="button_new"
                        // style={{ marginRight: "45px" }}
                      >
                        <i
                          className="fa fa-filter fa-fw requests-icons"
                          title="Show Filters"
                        ></i>
                      </a>
                    </div>
                    <div>
                      <a
                        onClick={() => downloadReport()}
                        onKeyDown={() => downloadReport()}
                        target="_blank"
                        className="button_new"
                      >
                        <i
                          className="fa fa-download requests-icons"
                          title="Download"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="max-w-100 overflow-auto">
                  <div className="table-responsive">
                  <table
  className="table table-bordered table-hover dataTable no-footer"
  style={{ tableLayout: "fixed" }}
>
  <thead>
    <tr style={{ backgroundColor: "#eee" }}>
      <th 
        className="text-center align-top py-2"
        width="7%"
      >
        S. No
      </th>
      <th 
        onClick={() => handleSort('name')}
        className={`text-center align-top py-2 td-sr ${sortColumn === 'name' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'name' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="15%"
      >
        Name
      </th>
      <th 
        onClick={() => handleSort('email')}
        className={`text-center align-top py-2 td-sr ${sortColumn === 'email' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'email' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="25%"
      >
        Email ID
      </th>
      <th 
        onClick={() => handleSort('mobile_no')}
        className={`text-wrap text-center align-top py-2 td-sr ${sortColumn === 'mobile_no' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'mobile_no' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="15%"
      >
        Mobile Number
      </th>
      <th 
        onClick={() => handleSort('otp_count')}
        className={`text-wrap text-center align-top py-2 td-sr ${sortColumn === 'otp_count' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'otp_count' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="15%"
      >
       Resend OTP Count
      </th>
      <th 
        onClick={() => handleSort('created_at')}
        className={`text-center align-top py-2 td-sr ${sortColumn === 'created_at' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'created_at' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="20%"
      >
       Created Date
      </th>
      {/* <th 
        onClick={() => handleSort('status')}
        className={`text-center align-top py-2 td-sr ${sortColumn === 'status' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
        aria-sort={sortColumn === 'status' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
        width="10%"
      >
       Status
      </th> */}
      <th className="text-center align-top py-2" width="10%">
        Actions
      </th>
    </tr>
  </thead>
  <tbody>
    {userLists?.data?.length ? (
      userLists?.data?.filter((endUser) => userStatus ? endUser?.status === "1" : endUser?.status === "-1")
        ?.map((endUser, index) => {
          return (
            <tr key={endUser?.id}>
              <td>
                <div className={cellClasses}>
                  <div>{startIndex + index + 1}</div>
                </div>
              </td>
              <td className="sorting_1 text-start">
              {/* {endUser?.name ? endUser?.name :  ""} */}
              {endUser?.name ? (
                <Link
                  to={
                    auth?.roleId !== ROLES.customerSupport
                      ? `/alliance-manager/user-lists/user-details/${endUser?.id}`
                      : `/customer-support/user-lists/user-details/${endUser?.id}`
                  }
                  rel="noopener noreferrer"
                >
                  {endUser.name}
                </Link>
              ) : null}
              </td>
              <td>
                {endUser?.email || ""}
              </td>
              <td>
                <div className={cellClasses}>
                  {endUser?.mobile_no
                    ? endUser?.mobile_no?.replace("+91", "")
                    : ""}
                </div>
              </td>
              <td>
                <div className={cellClasses}>
                  {endUser?.otp_count || 0}
                </div>
              </td>
              <td>
                <div className={cellClasses}>
                {endUser?.created_at ? moment(endUser?.created_at).format("DD-MM-YY hh:mm A") : ""}
                </div>
              </td>
              {/* <td>
                <div className={cellClasses}>
                {endUser?.status == 1 ? "Active" : "Inactive"}
                </div>
              </td> */}
              {userStatus ? 
                <td>
                  {endUser?.otp_count == 3 ? (
                    <i
                      className="fa fa-circle fa-fw txt-pass"
                      title="Grant Permission"
                      style={{
                        cursor: "pointer",
                        color: "red", //15-11-2024 - OTP color changes - Subha
                      }}
                      onClick={() => setEnduserId(endUser?.id)}
                      onKeyDown={() => setEnduserId(endUser?.id)}
                    ></i>
                  ):(
                    <i
                    className="fa fa-circle fa-fw txt-fail"
                    // title="Grant Permission"
                    style={{
                      cursor: "",
                      color: "green", //15-11-2024 - OTP color changes - Subha
                    }}
                    // onClick={() => setEnduserId(endUser?.id)}
                    // onKeyDown={() => setEnduserId(endUser?.id)}
                  ></i>
                  )}
                </td> 
                :
                <td> 
                  <div className="ps-7 pt-2">
                    <i 
                      className="fa fa-trash" 
                      style={{ cursor: "pointer", color: "red" }}
                      onClick={() => setEnduserDeleteId(endUser?.id)}
                      onKeyDown={() => setEnduserDeleteId(endUser?.id)}
                      ></i>
                  </div>
                </td>
              }
            </tr>
          );
        })
    ) : (
      <tr>
        <td colSpan={8} className="p-2 text-center">
          {listLoading || isFetching ? <Loader /> : "No data found"}
        </td>
      </tr>
    )}
     {!userStatus && userLists?.data?.filter((endUser) => endUser?.status === "-1")?.length === 0 && <tr>
        <td colSpan={8} className="p-2 text-center">
           No data found
        </td>
      </tr>}
  </tbody>
</table>


                  </div>
                </div>
                <div className="d-flex justify-content-end mr-2">
                  {/* {userLists?.data?.length > limit && (
                    <Pagination
                      activePage={page}
                      itemsCountPerPage={limit}
                      totalItemsCount={userLists?.data?.total}
                      pageRangeDisplayed={5}
                      onChange={(number) => setPage(number)}
                    />
                  )} */}

                  {userLists?.count > limit && (
                    <Pagination
                      activePage={page}
                      itemsCountPerPage={limit}
                      totalItemsCount={userLists?.count || 0}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      // itemClass="page-item"
                      // linkClass="page-link"
                      // innerClass="pagination justify-content-center"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminPageContainer>
    </AliianceManagerLayout>
  );
};

export default UserLists;
